import React, { useState } from 'react'
import styles from './PasswordChangeModal.module.css'

const PasswordChangeModal = ({ isOpen, onClose, onSave, currentPassword }) => {
  const [passwords, setPasswords] = useState({
    current: '',
    new: '',
    confirm: ''
  })

  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false
  })

  const [errors, setErrors] = useState({})

  if (!isOpen) return null

  const validatePasswords = () => {
    const newErrors = {}

    if (!passwords.current) {
      newErrors.current = '기존 비밀번호를 입력해주세요.'
    } 


    if (!passwords.new) {
      newErrors.new = '새 비밀번호를 입력해주세요.'
    } else if (passwords.new.length < 8) {
      newErrors.new = '비밀번호는 8자 이상이어야 합니다.'
    }

    if (!passwords.confirm) {
      newErrors.confirm = '비밀번호를 다시 입력해주세요.'
    } else if (passwords.new !== passwords.confirm) {
      newErrors.confirm = '비밀번호가 일치하지 않습니다.'
    } else if (passwords.new === passwords.current) {
      newErrors.new = '기존 비밀번호와 다른 비밀번호를 사용해주세요.'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSave = () => {
    if (validatePasswords()) {
      onSave({
        currentPassword: passwords.current,
        newPassword: passwords.new
      })
      handleCancel()
    }
  }

  const handleCancel = () => {
    setPasswords({ current: '', new: '', confirm: '' })
    setErrors({})
    setShowPasswords({ current: false, new: false, confirm: false })
    onClose()
  }

  const togglePasswordVisibility = (field) => {
    setShowPasswords(prev => ({
      ...prev,
      [field]: !prev[field]
    }))
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>비밀번호 변경</h2>
        </div>

        <div className={styles.modalBody}>
          {/* 기존 비밀번호 */}
          <div className={styles.formGroup}>
            <label>기존 비밀번호</label>
            <div className={styles.passwordField}>
              <input
                type={showPasswords.current ? 'text' : 'password'}
                value={passwords.current}
                onChange={(e) => setPasswords({ ...passwords, current: e.target.value })}
                placeholder="기존 비밀번호를 입력하세요"
                className={errors.current ? styles.inputError : ''}
              />
              <button
                className={styles.toggleBtn}
                onClick={() => togglePasswordVisibility('current')}
              >
                <i className={showPasswords.current ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
              </button>
            </div>
            {errors.current && <span className={styles.errorText}>{errors.current}</span>}
          </div>

          {/* 새 비밀번호 */}
          <div className={styles.formGroup}>
            <label>변경할 비밀번호</label>
            <div className={styles.passwordField}>
              <input
                type={showPasswords.new ? 'text' : 'password'}
                value={passwords.new}
                onChange={(e) => setPasswords({ ...passwords, new: e.target.value })}
                placeholder="새 비밀번호를 입력하세요 (8자 이상)"
                className={errors.new ? styles.inputError : ''}
              />
              <button
                className={styles.toggleBtn}
                onClick={() => togglePasswordVisibility('new')}
              >
                <i className={showPasswords.new ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
              </button>
            </div>
            {errors.new && <span className={styles.errorText}>{errors.new}</span>}
          </div>

          {/* 비밀번호 확인 */}
          <div className={styles.formGroup}>
            <label>변경할 비밀번호 재확인</label>
            <div className={styles.passwordField}>
              <input
                type={showPasswords.confirm ? 'text' : 'password'}
                value={passwords.confirm}
                onChange={(e) => setPasswords({ ...passwords, confirm: e.target.value })}
                placeholder="새 비밀번호를 다시 입력하세요"
                className={errors.confirm ? styles.inputError : ''}
              />
              <button
                className={styles.toggleBtn}
                onClick={() => togglePasswordVisibility('confirm')}
              >
                <i className={showPasswords.confirm ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
              </button>
            </div>
            {errors.confirm && <span className={styles.errorText}>{errors.confirm}</span>}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.cancelBtn} onClick={handleCancel}>
            취소
          </button>
          <button className={styles.confirmBtn} onClick={handleSave}>
            확인
          </button>
        </div>
      </div>
    </div>
  )
}

export default PasswordChangeModal
